import { render, staticRenderFns } from "./FrzCtnChangeEnviroment.vue?vue&type=template&id=61f5b51f"
import script from "./FrzCtnChangeEnviroment.vue?vue&type=script&lang=js"
export * from "./FrzCtnChangeEnviroment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports